export const isDemoDomain = window.origin.includes("demo") || window.origin.includes("public")
export const isPublicDemo = window.origin.includes("public")
